<template>
  <div id="impact-donate-wrapper">
    <Donate :productId="productId" v-if="!isAchieved"></Donate>
    <div class="wwf-form donation-form donate-impact-wrapper" v-if="isAchieved">
      <div>
        <h2>{{ product.meta.projectTitle }} has reached its funding goal!</h2>
        <p class="tagline">Check out this other similar project that you may be interested in!</p>
        <a class="project-button" :href="redirectUrl">Similar Project</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Donate from '../donation/Donate.vue';

export default {
  name: "ImpactDonateWrapper",
  components: {
    Donate,
  },

  props: {
    productId: {
      type: String,
      required: true,
    },
    redirectUrl: {
      type: String,
      default: null,
    },
  },
  computed: {
    isAchieved() {
      const product = this.product;

      if (product && product.meta) {
        return product.meta.currentDonationAmount >= product.meta.goalAmount;
      }
      return false;
    },
    ...mapState({
      product: (state) => state.product.product,
    })
  },
};
</script>

<style scoped>
.donate-impact-wrapper h2 {
  margin-bottom: 2rem;
  font-size: 42px;
  line-height: 1.2;
  text-transform: none;
}

.wwf-form.donation-form .project-button {
  display: block;
  margin-bottom: 1rem;
  padding: 1rem;
  color: var(--wwfWhite);
  font-family: "Open sans";
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  background: var(--wwfOrange);
  border-radius: 3px;
}
.tagline {
  margin-bottom: 2rem;
  font-size: 1.6rem;
  font-family: "WWF", sans-serif;
}
</style>


// WEBPACK FOOTER //
// ImpactDonateWrapper.vue?7fbb0da6